import { getEnv } from '@/constants';

export const DEFAULT_SPEAKER_NAME_FONT = {
  name: 'Inter',
  url: getFontFullPath('Inter-Medium.ttf')
};

export const FONTS_DEFAULT = [
  DEFAULT_SPEAKER_NAME_FONT,
  {
    name: 'Playfair Display',
    url: getFontFullPath('PlayfairDisplay-Bold.ttf')
  },
  {
    name: 'Montagu Slab',
    url: getFontFullPath('MontaguSlab_24pt-Bold.ttf')
  },
  {
    name: 'Bangers',
    url: getFontFullPath('Bangers-Regular.ttf')
  },
  {
    name: 'Space Mono',
    url: getFontFullPath('SpaceMono-Bold.ttf')
  },
  {
    name: 'Source Code Pro',
    url: getFontFullPath('SourceCodePro-Bold.ttf')
  },
  {
    name: 'Rubik',
    url: getFontFullPath('Rubik-Bold.ttf')
  },
  {
    name: 'Roboto',
    url: getFontFullPath('Roboto-Medium.ttf')
  },
  {
    name: 'Raleway',
    url: getFontFullPath('Raleway-Bold.ttf')
  },
  {
    name: 'Poppins',
    url: getFontFullPath('Poppins-Bold.ttf')
  },
  {
    name: 'Merriweather',
    url: getFontFullPath('Merriweather-Bold.ttf')
  },
  {
    name: 'Nunito',
    url: getFontFullPath('Nunito-Bold.ttf')
  },
  {
    name: 'Montserrat',
    url: getFontFullPath('Montserrat-ExtraBold.ttf')
  },
  {
    name: 'Alegreya',
    url: getFontFullPath('Alegreya-Bold.ttf')
  },
  {
    name: 'Lato',
    url: getFontFullPath('Lato-Bold.ttf')
  },
  {
    name: 'Open Sans',
    url: getFontFullPath('OpenSans-Bold.ttf')
  },
  {
    name: 'Pacifico',
    url: getFontFullPath('Pacifico-Regular.ttf')
  },
  {
    name: 'Patrick Hand',
    url: getFontFullPath('PatrickHand-Regular.ttf')
  },
  {
    name: 'Manrope',
    url: getFontFullPath('Manrope-ExtraBold.ttf')
  },
  {
    name: 'Oswald',
    url: getFontFullPath('Oswald-Bold.ttf')
  },
  {
    name: 'Roboto Mono',
    url: getFontFullPath('RobotoMono-Bold.ttf')
  },
  {
    name: 'Monoton',
    url: getFontFullPath('Monoton-Regular.ttf')
  },
  {
    name: 'League Script',
    url: getFontFullPath('LeagueScript-Regular.ttf')
  }
];

function getFontFullPath(fontName: string): string {
  return `${getEnv('VUE_APP_CLOUD_FRONT_URL')}content-lab/fonts/${fontName}`;
}

export const BRAND_KIT_PATH = 'content-lab/filestack/brand_kit';
